import { adminRequest } from "./adminApi";

// Appels directs hors pipeline redux (one-shot + rapport), auth : cf. adminApi.js.

/** Établissements cibles possibles : [{id, name, hasProduct}] */
export const fetchDuplicateTargets = (productId) =>
  adminRequest({
    path: `/v2/admin/store/product/${productId}/duplicate-targets.json`,
  }).then((res) => (res.data.result && res.data.result.items) || []);

/** Duplique la suggestion vers les établissements donnés. Renvoie le rapport. */
export const duplicateSuggestion = (suggestionId, establishmentIds) =>
  adminRequest({
    method: "post",
    path: `/v2/admin/store/product/suggestion/${suggestionId}/duplicate.json`,
    data: { establishmentIds },
    headers: { "Content-Type": "application/json" },
  }).then((res) => (res.data.result && res.data.result.report) || []);
